import ApolloClient from 'apollo-boost';
import { API_URL } from './config';
import { DataError, Export, ExportFile } from './types';
import { GET_EXPORT_BY_ID } from './graphql';
import { getItem } from '@/utils/storage';

enum ErrorTypes {
  Unauthorized
}

const ERROR_MESSAGES = {
  UNAUTHORIZED: "You don't have permissions to access this resource.",
  DEFAULT: 'Something went wrong please try again.'
};

const handleErrors = (result: any) => {
  /*
  With GraphQl a call can result in multiple errors, but the unathorized error has the priority over the other errors
  therefore if unathorized error is found that will be returned to the UI. For now all other errors will return the default error message
  */
  if (result && result.errors) {
    const error = result.errors.find((element: any) => {
      return element.errorType === ErrorTypes[ErrorTypes.Unauthorized];
    });
    if (error) {
      return ERROR_MESSAGES.UNAUTHORIZED;
    }
    return ERROR_MESSAGES.DEFAULT;
  }
  return null;
};

const getExportById = (exportId: string) => {
  const client = new ApolloClient({
    uri: API_URL,
    headers: {
      Authorization: `${getItem('token')}`
    }
  });
  return client
    .query({
      query: GET_EXPORT_BY_ID,
      errorPolicy: 'all',
      variables: { exportId }
    })
    .then(result => {
      /*
      To get both data and errors alongside each other the errorPolicy should be defined to all or ignore.
      all is suggested as the best one but if catch callback is specified the promise will reject with that result instead of the being rejected with the result of the handleErrors function, therefore no catch callback is defined and it will handled all by handleErrors function
      */
      const parsedError = handleErrors(result);
      if (parsedError) {
        return Promise.reject(parsedError);
      } else if (result && result.data.getExportById) {
        return Promise.resolve(result.data.getExportById);
      }
    });
};

export { getExportById, Export, ExportFile };
